import PubSub from "underpub-js";
import gsap from 'gsap';

var Header = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Header',
	};

	$.extend(true, this.options, options);

};

Header.prototype.init = function() {

	var self = this;

	self.$secondaryLogo = self.options.$el.find(`.${self.options.baseClass}__logo__image--secondary`);
	self.$hamburger = self.options.$el.find(`.${self.options.baseClass}__hamburger`);

	PubSub.subscribe('Header:fadeOutSecondaryLogo', function() {
		self.fadeOutSecondaryLogo();
	});

	PubSub.subscribe('Header:updateHamburgerZIndex', function() {
		self.updateHamburgerZIndex();
	});

};

Header.prototype.fadeOutSecondaryLogo = function() {

	var self = this;

	gsap.to(self.$secondaryLogo, {
		duration: 1.5,
		ease: "power3.out",
		opacity: 0,
	});

};

Header.prototype.updateHamburgerZIndex = function() {

	var self = this;

	self.$hamburger.css('z-index', 105);

};

export default Header;
